export default __webpack_public_path__ + "static/media/Jost-Thin.57123e61.ttf";